import Label from "lib/Label";
import { Col, Row } from "react-bootstrap";
import "./index.scss";
import ErrorMessage from "lib/ErrorMessage";
import { useSelector,useDispatch } from "react-redux";
import Number from "lib/Number";
import { useState } from "react";
import { useEffect } from "react";
import { getCountriesCode, getDuplicateData } from "api/formDisplay";
import { setIsKeyDuplicate, setDuplicateStatus,clearDuplicateStatus } from 'redux/recursiveReducer';
import { setIsDuplicateFormInput, setSelectedData } from "redux/formDisplay";

const Mobile = (props) => {
    const {
        placeholder,
        label,
        value,
        onChange,
        onCountryCode,
        type,
        name,
        error,
        size,
        validators,
        is_disabled,selectedData,isEditable,
        formErr,
        setFormErr,
      clearFieldError,
      validate_duplication,
      validate_duplication_type,
      validate_duplication_by,
      error_messages,
      default_value : defaultValue
    } = props;
    //TODO : need to add the isEditable code
    let fieldErr = formErr[name]
    let callingCode = `${name}_code`
    let callingCodeErr = formErr[callingCode]
    const dispatch = useDispatch();
    const countryData = useSelector(
      (state) => state.staticData?.countryData
    );
    const status = useSelector(
      (state) => state.staticData?.status
    );
  const isValidateTriggered = useSelector(
    (state) => state?.formData?.isValidateTriggered
  );
  const organisation_id = useSelector(( state) => state.configurationReducer?.config)?.organisation_id
  const isDuplicateFormInput = useSelector((state) => state.formData.isDuplicateFormInput);
  const recursiveFormData = useSelector((state) => state.recursive?.recursiveFormData);
  const configurationId = useSelector((state) => state.conditionalRendering?.configurationId);
  const isKeyDuplicate = useSelector((state) => 
    Object.values(state?.recursive?.duplicates || {}).some((isDuplicate) => isDuplicate)
  );
  

  const IndirectEval = (evalString) =>{
    return eval(evalString)
  }
  let required = IndirectEval(validators?.required)
  useEffect(() => {
    if(countryData?.length == 0 && status === false){
        dispatch(getCountriesCode())
    }
  }, []);
    let options =[]
    options.push({ label: "Select", value: "" });
    for (let i in countryData) {
      let paramObj = {};
      if ("calling_code" in countryData[i]) {
        paramObj.label = `${countryData[i].country_name} (${countryData[i].calling_code}) `;
        paramObj.value = countryData[i].calling_code;  
        options.push(paramObj);
      }
    }
    const existingMobile = useSelector(state=>state?.recursive?.saveData)
    const editIndex = useSelector(state=>state.recursive.editIndex)
    
  const [selectCode, setSelectCode] = useState("");
  const [uniqueDataError,setUniqueDataError] = useState(false)
  const [mobile, setMobile] = useState("");
  let completeNum;

  const errActive = error && error?.length !== 0;
  const errorClass = errActive ? "error_outline" : "";

  const isToggled = useSelector((state) => state.formData.isToggled);
  const copiedData = useSelector((state) => state.formData.copiedData);
  const subworkflows = useSelector(
    (state) => state.userInfo.workflowUser.subworkflows
  );
  const workflow_id = subworkflows?._id;
  const handleCountryCode = (e) => {
    const re = /^[\+\d]?(?:[\d\s()]*)$/;
    const { name, value } = e.target;
    if (required &&  value != "" && re.test(value)) {
      setSelectCode(value);
      completeNum = value + "-" + mobile;
      onChange(name, completeNum);
    }else if(!required) {
      setSelectCode(value);
       completeNum = value + "-" + mobile;
      onChange(name, completeNum);
    } 
    if (formErr[callingCodeErr]) {
      clearFieldError && clearFieldError(callingCodeErr)
      delete(formErr[callingCodeErr])
      setFormErr && setFormErr(formErr)
    }
  };
                         
  const checkPreviousEnteredmobile = async(id) => {
   let  isDuplicate = false;
    existingMobile?.forEach((item,index)=>{
      if (item[id] === value && index !== editIndex){
        isDuplicate = true;
        setDuplicateStatus('mobile', isDuplicate);
        dispatch(setDuplicateStatus({ field: "mobile", isDuplicate: true }));
        setUniqueDataError(true)
      }else{
        setUniqueDataError(false)
        dispatch(clearDuplicateStatus({ field: "mobile" }));
      }
   })
   
}
useEffect(()=>{
    dispatch(setIsKeyDuplicate(isKeyDuplicate))
},[isKeyDuplicate])

    const handleChange = (e) => {
        const { name, value } = e.target
        const re = /^[0-9\b]+$/;
        if (value === '' || re.test(value)) {
            setMobile(value)
             clearFieldError && clearFieldError(callingCodeErr)
             completeNum =  selectCode +"-"+ value 
            onChange(name, completeNum)
        }
    }
  const onBlurCapture = async (event) => {
    let payload = {};
    if (validate_duplication_by == 'organisation') {
      payload = {
        [`source_data.subworkflows.${event.target.name}`]: recursiveFormData[event.target.name],
        organisation_id,
        name
      }
    } else {
      payload = {
        [`source_data.subworkflows.${event.target.name}`]: recursiveFormData[event.target.name],
        configuration_id: configurationId,
        name
      }
    }
    if (validate_duplication) {
      await checkDuplicate(payload);
    }
  };
  const checkDuplicate = async (data) => {
    let response;
    response = await (getDuplicateData(data));
    if(response?.data.length == 1 && response?.data[0]._id == workflow_id ){
      dispatch(setIsDuplicateFormInput({ [name]: false }));
      dispatch(setSelectedData({key : [`${name}_duplicated`], value : false  }));
    }
   else if (response.status.toLowerCase() == 'success' && !!response?.data.length) {
      dispatch(setIsDuplicateFormInput({ [name]: true }));
      dispatch(setSelectedData({key :  [`${name}_duplicated`], value : true }));
    }
    else if (response.status.toLowerCase() == 'success' && response?.data.length == 0) {
      dispatch(setSelectedData({  key : [`${name}_duplicated`], value : false }));
      dispatch(setIsDuplicateFormInput({ [name]: false }) );
    }
  }
    useEffect(() => {
        if(value){
            let data = value.split("-")
            setSelectCode(data[0])
            setMobile(data[1])
            checkPreviousEnteredmobile(name)
        }else if(defaultValue){
          setSelectCode(defaultValue);
          setMobile('')
        }
        else{
          setSelectCode('')
          setMobile('')
        }
     
    },)
    return (
      <>
        {label ? <Label label={label} validators={validators} /> : null}

        <div className="col-lg-3 col-md-12 col-sm-12 mt-1">
          <select
            name={name}
            className={`dropdown_container ${
              errorClass && !selectCode
                ? errorClass
                : callingCodeErr && mobile && !selectCode && isValidateTriggered
                ? "error_outline"
                : ""
            }  ${
              !isEditable && "radioDisabled"
            }`}
            placeholder={"+91"}
            value={selectCode || defaultValue}
            disabled={eval(is_disabled) ? true : isEditable ? false:true}
            maxLength={4}
            onChange={handleCountryCode}
          >
            {countryData.length &&
              options?.map((item, index) => {
                let  { label, value } = item;
                return (
                  <option
                    key={index}
                    value={value}
                    className="dropdown_list"
                  >
                    {label}
                  </option>
                );
              })}
          </select>

          {error?.length !== 0 && !selectCode  ? (
            <ErrorMessage error={"This field is mandatory"} />
          ) : callingCodeErr && mobile && !selectCode && isValidateTriggered ? (
            <ErrorMessage error={"This field is mandatory"} />
          ) : null}
        </div>
        <div className="col-lg-9 col-md-12 col-sm-12 mobile_number_container mt-sm-1">
          <Number
            name={name}
            is_disabled={is_disabled}
            placeholder={placeholder}
            value={mobile}
            className={`form-mobile ${errorClass} ${uniqueDataError ? "duplicate_error" : ""}  ${!isEditable && "radioDisabled"}`}
   
            onChange={handleChange}
            onBlur={onBlurCapture}
            isEditable={isEditable}
            disabled={eval(is_disabled) ? true : isEditable ? false:true}
            error={
              error && !mobile
                ? error
                :  fieldErr 
                ? [fieldErr? fieldErr?.err:"This field mandatory"]
                : null
            }
          />
            {uniqueDataError ? <span className='duplicate_code_error'>{label} should be unique</span> : null} 
            {(isDuplicateFormInput[name] == true) && (recursiveFormData[name]?.length > 0) ? <span className='duplicate_code_error'>{error_messages?.duplicate_error}</span> : null}

        </div>
    </>
  );
};

export default Mobile;
